(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class TabsCustom extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.abortController = new AbortController();
      this.mobileBreakpoint = 750;
    }

    get tabs() {
      return Array.from(this.querySelectorAll('[role="tab"]'));
    }

    get panels() {
      return Array.from(this.querySelectorAll('[role="tabpanel"]'));
    }

    get accordionTriggers() {
      return Array.from(this.querySelectorAll('.tabs__accordion-trigger'));
    }

    isMobile() {
      return window.innerWidth < this.mobileBreakpoint;
    }

    connectedCallback() {
      var self = this;
      var signal = this.abortController.signal;

      // Populate tab headings from data attributes
      this.populateTabHeadings();

      this.tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
          self.selectTab(index);
        }, { signal: signal });
        tab.addEventListener('keydown', function(e) {
          self.handleKeydown(e, index);
        }, { signal: signal });
      });

      this.accordionTriggers.forEach(function(trigger, index) {
        trigger.addEventListener('click', function() {
          self.toggleAccordion(index);
        }, { signal: signal });
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function(e) {
          self.handleBlockSelect(e);
        }, { signal: signal });
      }

      this.selectTab(0, false);
      this.initMobileAccordion();
    }

    populateTabHeadings() {
      var panels = this.querySelectorAll('.tabs__panel-wrapper');
      var tabs = this.tabs;

      panels.forEach(function(panel, index) {
        var heading = panel.getAttribute('data-tab-heading');
        if (heading && tabs[index]) {
          tabs[index].textContent = heading;
        }
      });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    initMobileAccordion() {
      var self = this;
      this.accordionTriggers.forEach(function(trigger, index) {
        if (trigger.hasAttribute('data-open-default') && self.isMobile()) {
          self.toggleAccordion(index);
        }
      });
    }

    selectTab(index, focus) {
      var tabs = this.tabs;
      var panels = this.panels;

      if (focus === undefined) focus = true;
      if (index < 0 || index >= tabs.length) return;

      this.activeIndex = index;

      tabs.forEach(function(tab, i) {
        var isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) {
          tab.classList.add('tabs__tab--active');
        } else {
          tab.classList.remove('tabs__tab--active');
        }
      });

      panels.forEach(function(panel, i) {
        var isActive = i === index;
        if (isActive) {
          panel.classList.add('tabs__panel--active');
          panel.hidden = false;
        } else {
          panel.classList.remove('tabs__panel--active');
          panel.hidden = true;
        }
      });

      if (focus && tabs[index]) {
        tabs[index].focus();
      }
    }

    toggleAccordion(index) {
      var triggers = this.accordionTriggers;
      var panels = this.panels;

      if (index < 0 || index >= triggers.length) return;

      var trigger = triggers[index];
      var panel = panels[index];
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        panel.classList.remove('tabs__panel--active');
      } else {
        triggers.forEach(function(t, i) {
          t.setAttribute('aria-expanded', 'false');
          if (panels[i]) {
            panels[i].hidden = true;
            panels[i].classList.remove('tabs__panel--active');
          }
        });

        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.classList.add('tabs__panel--active');
        this.activeIndex = index;
      }
    }

    handleKeydown(event, currentIndex) {
      var tabs = this.tabs;
      var newIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          newIndex = (currentIndex + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          event.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          newIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      this.selectTab(newIndex, true);
    }

    handleBlockSelect(event) {
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) return;

      var panels = this.panels;
      var panelIndex = -1;

      for (var i = 0; i < panels.length; i++) {
        if (panels[i].id === 'tabpanel-' + blockId) {
          panelIndex = i;
          break;
        }
      }

      if (panelIndex !== -1) {
        this.selectTab(panelIndex, false);
        if (this.isMobile()) {
          this.toggleAccordion(panelIndex);
        }
      }
    }
  }

  if (!customElements.get('tabs-custom')) {
    customElements.define('tabs-custom', TabsCustom);
  }
  } catch(e) { console.error(e); }
})();

})();
